import qs from 'qs'
import { RouterStore } from 'mobx-react-router'
import { store } from './stores-repository'
import { computed, autorun } from 'mobx'

@store
export class RoutingStore extends RouterStore {

    static storeName: string = 'routingStore'

    pathNamesLog: string[] = []

    constructor() {
        super()
        autorun(() => {
            if (this.location && this.location.pathname !== this.pathNamesLog[this.pathNamesLog.length - 1]) {
                this.pathNamesLog = [...this.pathNamesLog, this.location.pathname]
            }

            /* чтобы память не текла */
            if (this.pathNamesLog.length > 30) {
                this.pathNamesLog = this.pathNamesLog.slice(this.pathNamesLog.length - 30)
            }
        })
    }

    @computed
    get queryParams(): {[key: string]: string} {
        const fixedLocationSearch: string = this.location.search.replace(/^\?/, '')
        return qs.parse(fixedLocationSearch) || {}
    }
}
